import { Box, Typography } from "@mui/material";
import FanToleranceWidget from "../../Widgets/Tolerance/Fan/Fan";
import { useTranslation } from "react-i18next";

const FanTolerancePage = () => {
  return (
    <Box >
      <Typography m={3} variant="h3">Fan</Typography>
      <FanToleranceWidget />
    </Box>
  );
};

export default FanTolerancePage;
